import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Intro from "../pages/intro/page";
import Onboarding from "../pages/onboarding/page";
import Home from "../pages/home/page";
import Yangbok from "../pages/yangbok/page";
import Guide from "../pages/guide/page";
import Diagnose from "../pages/diagnose/page";
import Result from "../pages/result/page";
import Vendors from "../pages/vendors/page";
import VendorDetail from "../pages/vendorDetail/page";
import Reviews from "../pages/reviews/page";
import Quote from "../pages/quote/page";
import Quotes from "../pages/quotes/page";
import My from "../pages/my/page";
import YangbokPage from "@/pages/YangbokOrg/page";
import YangbokForm from "@/pages/YangbokOrg/YangbokForm";
import Form from "@/pages/YangbokOrg/Form";
import QuestionResult from "@/pages/YangbokOrg/QuestionResult";
import YangbokListPage from "@/pages/YangbokOrg/YangbokListPage";
import YangbokDetailPage from "@/pages/YangbokOrg/YangbokDetailPage";
import YangbokQuestionResultPage from "@/pages/YangbokOrg/result/YangbokQuestionResultPage";
import YangbokV5TestPage from "@/pages/yangbok-v5/test/page";
import PhotosPage from "@/pages/yangbok-v5/test/photos/page";
import LookbookPage from "@/pages/yangbok-v5/test/lookbook/page";
import ReviewsPage from "@/pages/yangbok-v5/test/reviews/page";
import PartnerShopPreviewPage from "@/pages/yangbok-v5/test/PartnerShopPreviewPage";
import PartnerShopListPage from "@/pages/shop-list/Page";
import Main4Page from "@/pages/main/page";
import AppLayout from "@/components/AppLayout";

const routes: RouteObject[] = [
  {
    element: <AppLayout />,
    children: [
      {
        path: "/",
        element: <Main4Page />,
      },
      {
        path: "/list/:type",
        element: <PartnerShopListPage />,
      },
      {
        path: '/detail/:shopSlug',
        element: <YangbokV5TestPage />
      },
      {
        path: '/detail/:shopSlug/photos',
        element: <PhotosPage />
      },
      {
        path: '/detail/:shopSlug/lookbook',
        element: <LookbookPage />
      },
      {
        path: '/detail/:shopSlug/reviews',
        element: <ReviewsPage />
      },
    ]
  },
  {
    // path: "/",
    // element: <Intro />,
  },
  ,






  {
    path: "/onboarding",
    element: <Onboarding />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/yangbok-readdy",
    element: <YangbokPage />,
  },
  // {
  //   path: "/",
  //   element: <Form />,
  // },
  // {
  //   path: "/list",
  //   element: <PartnerShopListPage />,
  // },
  {
    path: '/result',
    element: <QuestionResult />
  },
  {
    path: '/result-v3/:resultKey',
    element: <YangbokQuestionResultPage />
  },
  {
    path: '/yangbok/list',
    element: <YangbokListPage />
  },
  {
    path: '/yangbok/detail/test',
    element: <YangbokDetailPage />
  },
  
  {
    path: "/yangbok",
    element: <YangbokForm />,
  },
  {
    path: "/yangbok/preview",
    element: <PartnerShopPreviewPage />,
  },
  
  {
    path: "/guide/:category",
    element: <Guide />,
  },
  {
    path: "/diagnose/:category",
    element: <Diagnose />,
  },
  {
    path: "/result/:category",
    element: <Result />,
  },
  {
    path: "/vendors",
    element: <Vendors />,
  },
  {
    path: "/vendor/:id",
    element: <VendorDetail />,
  },
  {
    path: "/reviews",
    element: <Reviews />,
  },
  {
    path: "/quote",
    element: <Quote />,
  },
  {
    path: "/quotes",
    element: <Quotes />,
  },
  {
    path: "/my",
    element: <My />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;